import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/contact.css';
import SEO from '../components/SEO';

const ThankYouDemo: React.FC = () => {
  return (
    <div className="contact-page">
      <SEO
        title="Thank You"
        description="We received your demo request and will follow up within one business day."
        path="/request-demo/thank-you"
        noindex
      />
      <div className="contact-intro">
        <p className="hero-eyebrow">Request received</p>
        <h1>Thank you!</h1>
        <p>
          We received your demo request. A member of our team will reach out
          within one business day.
        </p>
        <p>
          In the meantime, feel free to explore our{' '}
          <Link to="/product">products</Link> or learn{' '}
          <Link to="/about">about us</Link>.
        </p>
      </div>
    </div>
  );
};

export default ThankYouDemo;
